import { Component, Input, OnInit } from "@angular/core";
import {
  NgbModal,
  NgbActiveModal,
  NgbDateStruct,
  NgbCalendar,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { MigrerDossier } from 'src/app/core/services/business/model/migrer-dossier';
import { ProcessInstanceService } from 'src/app/parametrage/core/service/process-instances.service';
import { ProcessInstances } from 'src/app/parametrage/core/model/bpmn/process-instance';

@Component({
  selector: 'app-migrer-dossier',
  templateUrl: './migrer-dossier.component.html',
  styleUrls: ['./migrer-dossier.component.scss']
})
export class MigrerDossierComponent implements OnInit {

  errorMessage: String = null;
  form2: FormGroup;
  pressButton: Boolean = false;

  migrerDossier: MigrerDossier = new MigrerDossier();

  @Input() currentTaskId;
  @Input() requestId;
  @Input() processInstanceId;

  processInstances : ProcessInstances;

  constructor(
    private _router: Router,
    private _requestService: RequestService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _processInstanceService : ProcessInstanceService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      toProcessDefinitionKey: [null, Validators.compose([Validators.required])],
      toProcessDefinitionVersion: [null, Validators.compose([Validators.required])],
      processInstanceId: [null, Validators.compose([Validators.required])],
      cancelActivityId: [null, Validators.compose([Validators.required])],
      startActivityId: [null, Validators.compose([Validators.required])],
      requestId: [null, Validators.compose([Validators.required])],
      taskId: [null, Validators.compose([Validators.required])],
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.migrerDossier.taskId = this.currentTaskId;
    this.migrerDossier.requestId = this.requestId;
    this.migrerDossier.processInstanceId = this.processInstanceId;
    this.findCurrentChildrenOrSuperByRequestInstanceId(this.processInstanceId);
  }

  findCurrentChildrenOrSuperByRequestInstanceId(processInstanceId) {
    this._processInstanceService.findCurrentChildrenOrSuperByRequestInstanceId(processInstanceId).subscribe(
      (data) => {
        this.processInstances = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  change(): void {
    this.spinner.show();
    this._requestService
      .migrerDossier(this.migrerDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

}
